import type { IconNode } from '../types';

/**
 * @name hexagons-3
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCA0LjRhMiAyIDAgMCAwLTEgMS43M3Y0LjM3bC00IDIuNGEyIDIgMCAwIDAtMSAxLjczdjMuMjdhMiAyIDAgMCAwIC45NyAxLjY4TDYgMjEuNGEyIDIgMCAwIDAgMi4wMy0uMDJMMTIgMTlsNCAyLjRhMiAyIDAgMCAwIDIuMDMtLjAyTDIxIDE5LjZhMiAyIDAgMCAwIDEtMS43M1YxNC42YTIgMiAwIDAgMC0uOTctMS42OEwxNyAxMC41VjYuMWEyIDIgMCAwIDAtLjk3LTEuNjhMMTMgMi42YTIgMiAwIDAgMC0yLjAzLjAyWiIgLz4KICA8cGF0aCBkPSJtNyAxMC41IDUgMyA1LTMiIC8+CiAgPHBhdGggZD0iTTEyIDEzLjVWMTkiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/hexagons-3
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const hexagons3: IconNode = [
  [
    'path',
    {
      d: 'M8 4.4a2 2 0 0 0-1 1.73v4.37l-4 2.4a2 2 0 0 0-1 1.73v3.27a2 2 0 0 0 .97 1.68L6 21.4a2 2 0 0 0 2.03-.02L12 19l4 2.4a2 2 0 0 0 2.03-.02L21 19.6a2 2 0 0 0 1-1.73V14.6a2 2 0 0 0-.97-1.68L17 10.5V6.1a2 2 0 0 0-.97-1.68L13 2.6a2 2 0 0 0-2.03.02Z',
      key: '1oiigv',
    },
  ],
  ['path', { d: 'm7 10.5 5 3 5-3', key: '6ivmyf' }],
  ['path', { d: 'M12 13.5V19', key: '1mq4n6' }],
];

export default hexagons3;
